export default {"src":"/_next/static/media/arrow_right.9d1af07a.svg","height":10,"width":6,"blurWidth":0,"blurHeight":0};